import React, { Component } from "react";
import { Button, Form, Tooltip } from "antd";
import "../RegistrationCSS.css";
import { DownloadOutlined } from "@ant-design/icons";
import AndtDTextBoxWrapper from "swfrontend/MDM/MDMAntdWrappers/TextBoxWrapper";
import AndtDUploadWrapper from "swfrontend/MDM/MDMAntdWrappers/FileUploadWrapper";
import AndtDRadioButtonWrapper from "../../../../Components/CustomWrappers/RadioButtonWrapper";
import {
  FILE_UPLOAD_FIELDS,
  FILE_UPLOAD_RULES,
  DOWNLOAD_TOOLTIP,
  CIN_HELPER_TEXT,
} from "../../../../constants";
import {
  GSTValidator,
  CINValidator,
  TANValidator,
  PANValidator,
  AadharValidator,
  UdyamValidator,
} from "../validators";

class TaxationDetails extends Component {
  render() {
    const {
      uploadedFiles,
      addFile,
      removeFile,
      formRef,
      fileConfigs,
      gst_registration_status,
      tcs_applicable_status,
      is_tan_required,
      tan_number_status,
      cin_number_status,
      isCinEnabled,
      toggleHTMLControls,
      previewFile,
      isDisabled,
      validateGSTNumber,
      tcsStatus,
      validateAadharNumber,
      aadharRequired,
      req_op_fields,
      dec_letter_tooltip,
      is_gst_required,
      is_udyam_required,
      onChangeText,
      is_udyam_visible,
      cinRequiredIndustry,
      is_reverted_in_mdm
    } = this.props;

    // const isCinFileEnabled =  cin_number_status&&!uploadedFiles.hasOwnProperty('cin_document')?true:isCinEnabled
    const isCinFileEnabled =  cin_number_status&&(!uploadedFiles.hasOwnProperty('cin_document')||(uploadedFiles.hasOwnProperty('cin_document')&&uploadedFiles['cin_document'].length===0))?true:isCinEnabled

    return (
      <div className="row form-box">
        <legend className="form-legend">Taxation Details</legend>

        <div className="col-lg-6 col-md-12">
          <AndtDTextBoxWrapper
            decorator="pan_number"
            id="Pan Number"
            required={"pan_number" in req_op_fields["O"] ? false : true}
            disabled={"pan_number" in req_op_fields["S"] ? true : isDisabled}
            label="PAN Number"
            message="Enter Pan Number"
            placeholder="Enter Pan Number"
            validators={[{ validator: PANValidator }]}
            casetype="uppercase"
            maxlength={10}
            onChangeText={validateAadharNumber}
            formRef={formRef}
          />
        </div>

        {fileConfigs[FILE_UPLOAD_FIELDS.pan_document] !== undefined && (
          <div className="col-lg-6 col-md-12">
            <AndtDUploadWrapper
              name="pan_document"
              label="PAN Document Upload"
              decorator="pan_document"
              required={"pan_document" in req_op_fields["O"] ? false : true}
              disabled={
                "pan_document" in req_op_fields["S"] ? true : isDisabled
              }
              message="Please Select PAN Document"
              removeFile={removeFile}
              validators={[]}
              files_limit={
                fileConfigs[FILE_UPLOAD_FIELDS.pan_document][
                  FILE_UPLOAD_RULES.totalfiles
                ]
              }
              file_size_limit_mb={
                fileConfigs[FILE_UPLOAD_FIELDS.pan_document][
                  FILE_UPLOAD_RULES.filesize
                ]
              }
              accept_file_type={
                fileConfigs[FILE_UPLOAD_FIELDS.pan_document][
                  FILE_UPLOAD_RULES.allowtypes
                ]
              }
              uploadFileList={uploadedFiles}
              previewFile={previewFile}
              addFile={addFile}
              formRef={formRef}
            />
          </div>
        )}

        {/* <div className="col-lg-6 col-md-12">
          <AndtDTextBoxWrapper
            decorator="aadhar_number"
            id="Aadhar Number"
            required={
              "aadhar_number" in req_op_fields["O"] ? false : aadharRequired
            }
            disabled={"aadhar_number" in req_op_fields["S"] ? true : isDisabled}
            label="Aadhar Card Number"
            message="Enter Aadhar Card Number"
            placeholder="Enter Aadhar Card Number"
            validators={aadharRequired ? [{ validator: AadharValidator }] : ""}
            casetype="uppercase"
            maxlength={12}
            formRef={formRef}
          />
        </div> */}

        {/* {fileConfigs[FILE_UPLOAD_FIELDS.aadhar_card_document] !== undefined && (
          <div className="col-lg-6 col-md-12">
            <AndtDUploadWrapper
              name="aadhar_card_document"
              label="Aadhar Card Document Upload"
              decorator="aadhar_card_document"
              required={
                "aadhar_card_document" in req_op_fields["O"]
                  ? false
                  : aadharRequired
              }
              disabled={
                "aadhar_card_document" in req_op_fields["S"] ? true : isDisabled
              }
              message="Please Select Aadhar Document"
              removeFile={removeFile}
              validators={[]}
              files_limit={
                fileConfigs[FILE_UPLOAD_FIELDS.aadhar_card_document][
                  FILE_UPLOAD_RULES.totalfiles
                ]
              }
              file_size_limit_mb={
                fileConfigs[FILE_UPLOAD_FIELDS.aadhar_card_document][
                  FILE_UPLOAD_RULES.filesize
                ]
              }
              accept_file_type={
                fileConfigs[FILE_UPLOAD_FIELDS.aadhar_card_document][
                  FILE_UPLOAD_RULES.allowtypes
                ]
              }
              uploadFileList={uploadedFiles}
              previewFile={previewFile}
              addFile={addFile}
              formRef={formRef}
            />
          </div>
        )} */}

        <div className="col-lg-6 col-md-12">
          <AndtDRadioButtonWrapper
            decorator="gst_registration_status"
            id="GST Registration"
            required={
              is_gst_required
                ? true
                : "gst_registration_status" in req_op_fields["O"]
                ? false
                : true
            }
            disabled={
              is_gst_required
                ? true
                : "gst_registration_status" in req_op_fields["S"]
                ? true
                : isDisabled
            }
            label="GST Registration"
            message="Enter GST Registration"
            placeholder="Enter GST Registration"
            radioType="radio"
            validators=""
            onChangeRadio={toggleHTMLControls}
            options={[
              { id: "true", name: "Yes", value: true },
              { id: "false", name: "No", value: false },
            ]}
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AndtDTextBoxWrapper
            decorator="gst_number"
            id="GST Number"
            required={
              is_gst_required
                ? true
                : "gst_number" in req_op_fields["O"]
                ? false
                : gst_registration_status
            }
            disabled={
              "gst_number" in req_op_fields["S"]
                ? true
                : isDisabled
                ? true
                : is_gst_required
                ? false
                : !gst_registration_status
            }
            label="GST Number"
            message="Enter GST Number"
            placeholder="Enter GST Number"
            validators={
              gst_registration_status ? [{ validator: GSTValidator }] : ""
            }
            onChangeText={validateGSTNumber}
            maxlength={15}
            casetype="uppercase"
            formRef={formRef}
          />
        </div>

        {fileConfigs[FILE_UPLOAD_FIELDS.gst_document] !== undefined && (
          <div className="col-lg-6 col-md-12">
            <AndtDUploadWrapper
              name="gst_document"
              label="GST Document Upload"
              decorator="gst_document"
              required={
                is_gst_required
                  ? true
                  : "gst_document" in req_op_fields["O"]
                  ? false
                  : gst_registration_status
              }
              disabled={
                "gst_document" in req_op_fields["S"]
                  ? true
                  : isDisabled
                  ? true
                  : is_gst_required
                  ? false
                  : false
              }
              message="Please Select GST Document"
              removeFile={removeFile}
              files_limit={
                fileConfigs[FILE_UPLOAD_FIELDS.gst_document][
                  FILE_UPLOAD_RULES.totalfiles
                ]
              }
              file_size_limit_mb={
                fileConfigs[FILE_UPLOAD_FIELDS.gst_document][
                  FILE_UPLOAD_RULES.filesize
                ]
              }
              accept_file_type={
                fileConfigs[FILE_UPLOAD_FIELDS.gst_document][
                  FILE_UPLOAD_RULES.allowtypes
                ]
              }
              validators={[]}
              uploadFileList={uploadedFiles}
              previewFile={previewFile}
              addFile={addFile}
              formRef={formRef}
            />
          </div>
        )}

        <div className="col-lg-6 col-md-12">
          <AndtDRadioButtonWrapper
            decorator="tcs_applicable_status"
            id="TCS Applicable Status"
            required={
              "tcs_applicable_status" in req_op_fields["O"] ? false : true
            }
            disabled={
              "tcs_applicable_status" in req_op_fields["S"] ? true : isDisabled
            }
            label="Tax Collection at Source(TCS) / Tax Deduaction at Source (TDS) Applicability"
            message="Enter TCS Applicable Status"
            placeholder="Enter TCS Applicable Status"
            radioType="radio"
            validators=""
            onChangeRadio={toggleHTMLControls}
            options={tcsStatus}
            isVertical={true}
            formRef={formRef}
          />
        </div>

        {fileConfigs[FILE_UPLOAD_FIELDS.tcs_applicable_status_file] !==
          undefined && (
          <>
            <div className="col-lg-3 col-md-12">
              <AndtDUploadWrapper
                id="tcs_applicable_status_file"
                name="tcs_applicable_status_file"
                label="TCS/TDS Declaration Attachment"
                decorator="tcs_applicable_status_file"
                required={
                  "tcs_applicable_status_file" in req_op_fields["O"]
                    ? false
                    : tcs_applicable_status
                }
                disabled={
                  "tcs_applicable_status_file" in req_op_fields["S"]
                    ? true
                    : isDisabled
                    ? true
                    : !tcs_applicable_status
                }
                message="Please Select TCS Applicable Status Files"
                removeFile={removeFile}
                validators={[]}
                files_limit={
                  fileConfigs[FILE_UPLOAD_FIELDS.tcs_applicable_status_file][
                    FILE_UPLOAD_RULES.totalfiles
                  ]
                }
                file_size_limit_mb={
                  fileConfigs[FILE_UPLOAD_FIELDS.tcs_applicable_status_file][
                    FILE_UPLOAD_RULES.filesize
                  ]
                }
                accept_file_type={
                  fileConfigs[FILE_UPLOAD_FIELDS.tcs_applicable_status_file][
                    FILE_UPLOAD_RULES.allowtypes
                  ]
                }
                uploadFileList={uploadedFiles}
                previewFile={previewFile}
                addFile={addFile}
                formRef={formRef}
              />
            </div>
            <div className="col-lg-2 col-md-12 template">
              <Form.Item label={`  `}>
                <Tooltip title={DOWNLOAD_TOOLTIP}>
                  <Button>
                    <a
                      href={`${
                        process.env.REACT_APP_PROJECT_ROUTE !== "/null"
                          ? process.env.REACT_APP_PROJECT_ROUTE
                          : ""
                      }/TCS-TDC declaration attachment.docx`}
                      download
                    >
                      <DownloadOutlined /> Declaration
                    </a>
                  </Button>
                </Tooltip>
              </Form.Item>
            </div>
            <div className="col-lg-1 col-md-12"></div>
          </>
        )}

        <div className="col-lg-6 col-md-12">
          <AndtDRadioButtonWrapper
            decorator="tan_number_status"
            id="TAN Number"
            required={"tan_number_status" in req_op_fields["O"] ? false : true}
            disabled={
              is_tan_required
                ? true
                : "tan_number_status" in req_op_fields["S"]
                ? true
                : isDisabled
            }
            label="Is TAN Registered ?"
            message="Enter TAN Number"
            placeholder="Enter TAN Number"
            radioType="radio"
            validators=""
            onChangeRadio={toggleHTMLControls}
            options={[
              { id: "true", name: "Yes", value: true },
              { id: "false", name: "No", value: false },
            ]}
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AndtDTextBoxWrapper
            decorator="tan_number"
            id="TAN Number Text"
            required={
              is_tan_required
                ? true
                : "tan_number" in req_op_fields["O"]
                ? false
                : tan_number_status
            }
            disabled={
              is_tan_required
                ? false
                : "tan_number" in req_op_fields["S"]
                ? true
                : isDisabled
                ? true
                : !tan_number_status
            }
            label="TAN Number"
            message="Enter TAN Number"
            placeholder="Enter TAN Number"
            validators={[{ validator: TANValidator }]}
            maxlength={10}
            casetype="uppercase"
            formRef={formRef}
          />
        </div>

        {fileConfigs[FILE_UPLOAD_FIELDS.tan_document] !== undefined && (
          <div className="col-lg-6 col-md-12">
            <AndtDUploadWrapper
              name="tan_document"
              label="TAN Document"
              decorator="tan_document"
              required={
                is_tan_required
                  ? true
                  : "tan_document" in req_op_fields["O"]
                  ? false
                  : tan_number_status
              }
              disabled={
                is_tan_required
                  ? false
                  : "tan_document" in req_op_fields["S"]
                  ? true
                  : isDisabled
                  ? true
                  : !tan_number_status
              }
              message="TAN allotment letter"
              removeFile={removeFile}
              validators={[]}
              files_limit={
                fileConfigs[FILE_UPLOAD_FIELDS.tan_document][
                  FILE_UPLOAD_RULES.totalfiles
                ]
              }
              file_size_limit_mb={
                fileConfigs[FILE_UPLOAD_FIELDS.tan_document][
                  FILE_UPLOAD_RULES.filesize
                ]
              }
              accept_file_type={
                fileConfigs[FILE_UPLOAD_FIELDS.tan_document][
                  FILE_UPLOAD_RULES.allowtypes
                ]
              }
              uploadFileList={uploadedFiles}
              previewFile={previewFile}
              addFile={addFile}
              formRef={formRef}
            />
          </div>
        )}

        <div className="col-lg-6 col-md-12">
          <AndtDRadioButtonWrapper
            decorator="cin_number_status"
            id="CIN Number"
            required={"cin_number_status" in req_op_fields["O"] ? false : true}
            disabled={
              cinRequiredIndustry?true:"cin_number_status" in req_op_fields["S"] ? true : isDisabled
            }
            label="Is CIN Registered ?"
            message="Enter CIN Number"
            placeholder="Enter CIN Number"
            radioType="radio"
            validators=""
            onChangeRadio={toggleHTMLControls}
            options={[
              { id: "true", name: "Yes", value: true, disabled: cinRequiredIndustry ? true : undefined },
              { id: "false", name: "No", value: false, disabled: cinRequiredIndustry ? true : undefined },
            ]}
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AndtDTextBoxWrapper
            decorator="cin_number"
            id="CIN Number Text"
            required={
              "cin_number" in req_op_fields["O"] ? false : isCinEnabled
            }
            disabled={
              is_reverted_in_mdm ? false :
              !isCinEnabled?true:
              "cin_number" in req_op_fields["S"]
                ? true
                : isDisabled
                ? true
                : !cin_number_status
            }
            label="CIN Number"
            message="Enter CIN Number"
            placeholder="Enter CIN Number"
            validators={cin_number_status ? [{ validator: CINValidator }] : ""}
            maxlength={21}
            casetype="uppercase"
            formRef={formRef}
          />

          <p className="custom-tooltip-cin">{CIN_HELPER_TEXT}</p>
        </div>

        {fileConfigs[FILE_UPLOAD_FIELDS.cin_document] !== undefined && (
          <div
            className="col-lg-6 col-md-12"
          >
            <AndtDUploadWrapper
              name="cin_document"
              label="CIN Document Upload"
              decorator="cin_document"
              required={
                "cin_document" in req_op_fields["O"]
                  ? false
                  : isCinFileEnabled
              }
              disabled={
                is_reverted_in_mdm ? false :
                !isCinFileEnabled?true:
                "cin_document" in req_op_fields["S"]
                  ? true
                  : isDisabled
                  ? true
                  : !cin_number_status
              }
              message="Please Select CIN Document"
              removeFile={removeFile}
              validators={[]}
              files_limit={
                fileConfigs[FILE_UPLOAD_FIELDS.cin_document][
                  FILE_UPLOAD_RULES.totalfiles
                ]
              }
              file_size_limit_mb={
                fileConfigs[FILE_UPLOAD_FIELDS.cin_document][
                  FILE_UPLOAD_RULES.filesize
                ]
              }
              accept_file_type={
                fileConfigs[FILE_UPLOAD_FIELDS.cin_document][
                  FILE_UPLOAD_RULES.allowtypes
                ]
              }
              uploadFileList={uploadedFiles}
              previewFile={previewFile}
              addFile={addFile}
              formRef={formRef}
            />
          </div>
        )}

        {is_udyam_visible && (
          <>
            <div className="col-lg-6 col-md-12">
              <AndtDTextBoxWrapper
                decorator="udyam_number"
                id="udyam_number"
                required={true}
                disabled={
                  "udyam_number" in req_op_fields["S"]
                    ? true
                    : isDisabled && true
                }
                label="Udyam Registration Number"
                message="Enter Udyam Registration Number"
                placeholder="Enter Udyam Registration Number"
                validators={[{ validator: UdyamValidator }]}
                maxlength={19}
                casetype="uppercase"
                onChangeText={onChangeText}
                formRef={formRef}
              />
            </div>

            {fileConfigs[FILE_UPLOAD_FIELDS.udyam_document] !== undefined && (
              <div className="col-lg-6 col-md-12">
                <AndtDUploadWrapper
                  name="udyam_document"
                  label="Udyam Document Upload"
                  decorator="udyam_document"
                  required={
                    is_udyam_required
                      ? true
                      : "udyam_document" in req_op_fields["O"] && false
                  }
                  disabled={
                    is_udyam_required
                      ? false
                      : "udyam_document" in req_op_fields["S"]
                      ? true
                      : isDisabled && true
                  }
                  message="Udyam Registration Document"
                  removeFile={removeFile}
                  validators={[]}
                  files_limit={
                    fileConfigs[FILE_UPLOAD_FIELDS.udyam_document][
                      FILE_UPLOAD_RULES.totalfiles
                    ]
                  }
                  file_size_limit_mb={
                    fileConfigs[FILE_UPLOAD_FIELDS.udyam_document][
                      FILE_UPLOAD_RULES.filesize
                    ]
                  }
                  accept_file_type={
                    fileConfigs[FILE_UPLOAD_FIELDS.udyam_document][
                      FILE_UPLOAD_RULES.allowtypes
                    ]
                  }
                  uploadFileList={uploadedFiles}
                  previewFile={previewFile}
                  addFile={addFile}
                  formRef={formRef}
                />
              </div>
            )}
          </>
        )}
      </div>
    );
  }
}

export default TaxationDetails;
